import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { fetchModules, markModulesAsViewed, markModuleAsViewed, clearError } from '../store/inventorySlice';

export const useInventory = () => {
  const dispatch = useDispatch();
  const inventory = useSelector((state) => state.inventory);

  // Загрузить модули по типу
  const loadModules = useCallback((type = null) => {
    
    return dispatch(fetchModules(type));
  }, [dispatch]);

  // Отметить модули как просмотренные
  const markAsViewed = useCallback((moduleIds) => {
    
    if (!Array.isArray(moduleIds) || moduleIds.length === 0) {
      console.warn('No module IDs provided');
      return Promise.resolve();
    }
    
    return dispatch(markModulesAsViewed(moduleIds));
  }, [dispatch]);

  // Отметить один модуль как просмотренный
  const markSingleModuleAsViewed = useCallback(async (moduleId) => {
    
    if (!moduleId) {
      console.warn('No module ID provided');
      return Promise.resolve();
    }
    
    return dispatch(markModuleAsViewed(moduleId));
  }, [dispatch]);
  const clearErrors = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  // Получить модули по типу
  const getModulesByType = useCallback((type = null) => {
    const cacheKey = type || 'all';
    return inventory.modules[cacheKey] || [];
  }, [inventory.modules]);

  // Получить новые модули
  const getNewModules = useCallback(() => {
    const allModules = inventory.modules.all || [];
    return allModules.filter(module => module.isNew);
  }, [inventory.modules.all]);

  // Получить количество новых модулей по типу
  const getNewCountByType = useCallback((type = null) => {
    const modules = getModulesByType(type);
    return modules.filter(module => module.isNew).length;
  }, [getModulesByType]);

  return {
    // Данные
    modules: inventory.modules,
    totalCount: inventory.totalCount,
    newCount: inventory.newCount,
    
    // Состояние
    isLoading: inventory.isLoading,
    error: inventory.error,
    
    // Методы
    loadModules,
    markAsViewed,
    markSingleModuleAsViewed,
    clearErrors,
    getModulesByType,
    getNewModules,
    getNewCountByType,
  };
};
